import script from "./DeclinedOffer.vue?vue&type=script&setup=true&lang=js"
export * from "./DeclinedOffer.vue?vue&type=script&setup=true&lang=js"

import "./DeclinedOffer.vue?vue&type=style&index=0&id=229ba36e&lang=css"

const __exports__ = script;

export default __exports__